import React, { Component } from 'react';

import * as dt from 'core/datetime';

import TimePickerDialog from './TimePickerDialog';

interface TimePickerProps {
  value: TimeIn24Hours;
  onChange(value: TimeIn24Hours): void;
}

interface TimePickerState {
  isOpen: boolean;
}

export default class TimePicker extends Component<TimePickerProps, TimePickerState> {
  state: TimePickerState = {
    isOpen: false,
  };

  render() {
    const { isOpen } = this.state;
    const { value, onChange } = this.props;
    return (
      <div onClick={() => this.setState({ isOpen: true })}>
        <span className='timepicker'>{dt.serialize24HoursTime(value)}</span>
        <TimePickerDialog
          isOpen={isOpen}
          value={value}
          onClose={(value) => {
            onChange(value);
            this.setState({ isOpen: false });
          }}
        />
      </div>
    );
  }
}
